import { useDefaultLocalizationTexts } from '@mews/framework';
import { OptimusProvider, OptimusProviderProps } from '@optimus-web/theme';

const densityPresets = {
    compact: {
        Autocomplete: { size: 'small' },
        Button: { size: 'small' },
        Checkbox: { size: 'small' },
        Stepper: { size: 'small' },
        Input: { size: 'small' },
        ListItem: { dense: true },
        Select: { size: 'small' },
    },
    spacious: {
        Autocomplete: { size: 'medium' },
        Button: { size: 'medium' },
        Checkbox: { size: 'medium' },
        Stepper: { size: 'medium' },
        Input: { size: 'medium' },
        ListItem: { dense: true },
        Select: { size: 'medium' },
    },
    extraSpacious: {
        Autocomplete: { size: 'large' },
        Button: { size: 'large' },
        Checkbox: { size: 'large' },
        Stepper: { size: 'large' },
        Input: { size: 'large' },
        ListItem: { dense: true },
        Select: { size: 'large' },
    },
} satisfies Record<string, OptimusProviderProps['componentsProps']>;

const Provider = ({
    children,
    density = 'compact',
}: {
    children: React.ReactNode;
    density?: keyof typeof densityPresets;
}) => (
    <OptimusProvider
        themeVariant="light"
        localizationTexts={useDefaultLocalizationTexts()}
        componentsProps={densityPresets[density]}
    >
        {children}
    </OptimusProvider>
);

export { Provider as OptimusProvider };
